export const ELECTRON_CONFIG_LOCATION_KEY = "device_location"
export const ELECTRON_CONFIG_NAME_KEY = "device_name"
export const ELECTRON_CONFIG_VIEW_POINT_KEY = "device_view_point" // One Siam
export const ELECTRON_CONFIG_HEADER_IMAGE_KEY = "header_image" // One Siam
export const ELECTRON_CONFIG_HEADER_IMAGE_OVERLAP_KEY = "header_image_overlap" // One Siam
export const ELECTRON_CONFIG_HOME_FOOTER_IMAGE_KEY = "home_footer_image" // One Siam
